import {Injectable} from "@angular/core";

@Injectable()
export class IdentificationService {
  constructor() {

  }

    public caller = null;
/*
  refreshToken(user, oauthBaseAuth, url) {
    console.log(this.caller.refreshToken);
    if (this.caller.refreshToken) {
      return this.caller.refreshToken(user, oauthBaseAuth, url);
    }
    return null;

  }
*/


}



// WEBPACK FOOTER //
// ./src/app/services/httpClient/identification.service.ts